import * as types from '../constants/ActionTypes';

export const setHomePage = () => ({ type: types.HOME_PAGE });
export const setProdPage = () => ({ type: types.ORDER_PAGE });
export const setOrderHistoryPage = () => ({ type: types.ORDERHISTORY_PAGE});
export const setPlanningPage = () => ({ type: types.PLANNING_PAGE});
export const setHelpPage = () => ({ type: types.HELP_PAGE});
export const setOrderInfoPage = (orderNumber) => ({type: types.ORDERINFO_PAGE, orderNumber: orderNumber})
export const setCncInfoPage = (orderNumber) => ({type: types.CNCINFO_PAGE, orderNumber: orderNumber})
export const setOrderHist = (searchText) => ({type: types.SET_ORDERHIST_SEARCH, searchText: searchText})
export const setProdOrderHist = (searchText) => ({type: types.SET_PRODORDERHIST_SEARCH, searchText: searchText})
export const setPlanningSearchDates = (startDate, endDate) => ({type: types.SET_PLANNING_SEARCH_DATE, startDate: startDate, endDate: endDate})